<template>
  <div>
    <Navbar />
    <Announcements />
    <NuxtChild />
    <FooterHero />
  </div>
</template>
<script>
import Navbar from '~/components/Navbar.vue'
import FooterHero from '~/components/Footer'
import Announcements from '~/components/Announcements'

export default {
  auth: false,
  components: {
    Navbar,
    FooterHero,
    Announcements
  },
  data () {
    return {}
  }
}
</script>
